<template>
	<node-view-wrapper class="data-chip">
		<div class="content-display pa-1">
			<div class="value-text">{{ text }}</div>
			<AnemicButton v-if="canDelete" @mousedown="deleteChip" class="ml-1 close-button flex-centerize">
				<v-icon class="close-icon">mdi-close</v-icon>
			</AnemicButton>
		</div>
	</node-view-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';
import { deleteMultiSelectFieldFromParam } from '@/store/modules/selectedNode/actions';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'MultiSelectChip',
	components: { NodeViewWrapper },
	props: nodeViewProps,
	computed: {
		...mapGetters([projectHasPermission.fullPath, getWorkflow.fullPath]),
		canDelete() {
			return this[projectHasPermission.fullPath](
				this[getWorkflow.fullPath](this.node.workflow)?.project,
				ProjectPermissions.ChangeWorkflows
			);
		},
		params() {
			return this.node.attrs;
		},
		text() {
			return this.params.text;
		},
		value() {
			return this.params.value;
		},
		paramKey() {
			return this.params.paramKey;
		},
	},
	methods: {
		...mapActions([deleteMultiSelectFieldFromParam.fullPath]),
		deleteChip() {
			this[deleteMultiSelectFieldFromParam.fullPath]({ paramKey: this.paramKey, value: this.value?.toString() });
		},
	},
};
</script>

<style scoped lang="scss">
.data-chip {
	border: none;
	display: inline-flex;
	position: relative;
	border-radius: 3px;
	margin: 0 2px 2px 0;

	.content-display {
		display: inline;
		border-radius: 8px;
		background: var(--bg-color);
		border: 1px solid var(--border-color);
		color: var(--primary-font-color);

		&:hover {
			transition: 0.2s;
			box-shadow: var(--card-shadow);
		}

		.value-text {
			font-size: 12px;
			margin-top: -2px;
			display: inline-flex;
			vertical-align: middle;
			color: var(--primary-font-color);
		}

		.close-button {
			width: 14px;
			height: 30px;
			padding: 0px;
			margin-top: -1px;
			display: inline-flex;
			vertical-align: middle;
			background: transparent;
			.close-icon {
				font-size: 12px;
			}
		}
	}
}
</style>
